import { FC, memo } from 'react';

import { TabPanel, TabView } from 'primereact/tabview';

import cn from 'classnames';

import useBackgroundEffectsTabs from './useBackgroundEffectsTabs';

import { FaTrashAlt } from 'react-icons/fa';
import { FullyBlurredIcon, SlightlyBlurredIcon, UploadImageIcon } from '@src/assets/icons';

import { ANIMATED_BACKGROUND_VIDEOS, BACKGROUNDS, BLURRED_BACKGROUNDS } from '@src/constants';

import { TBackgroundEffect } from '@src/types';

import './BackgroundEffectsTabs.scss';

interface IProps {
  onSelectBackgroundEffect: (effect: TBackgroundEffect) => void;
}
const BackgroundEffectsTabs: FC<IProps> = ({ onSelectBackgroundEffect }) => {
  const { uploadedBackgrounds, selectedEffect, handleUploadImage, handleRemoveImage } = useBackgroundEffectsTabs({
    onSelectBackgroundEffect,
  });

  return (
    <TabView className="tabview">
      <TabPanel header="Images" className="backgrounds-section">
        <div className="backgrounds-section-grid">
          <label className="upload-box">
            <UploadImageIcon />
            <input type="file" accept="image/*" className="hidden" onChange={handleUploadImage} />
            <div className="upload-placeholder">Add image</div>
          </label>

          {uploadedBackgrounds.map((bg) => (
            <div key={bg.id} className="position-relative">
              <img
                src={bg.src}
                alt="Uploaded Background"
                className={cn('background-choice', {
                  selected: selectedEffect.type === 'image' && selectedEffect.value === bg.src,
                })}
                onClick={() => onSelectBackgroundEffect({ type: 'image', value: bg.src })}
              />
              <button className="trash-icon" onClick={() => handleRemoveImage(bg)}>
                <FaTrashAlt size={12} />
              </button>
            </div>
          ))}
          {BACKGROUNDS.map((bg) => (
            <img
              key={bg.id}
              src={bg.src}
              alt={bg.name}
              className={cn('background-choice', {
                selected: selectedEffect.type === 'image' && selectedEffect.value === bg.src,
              })}
              onClick={() => onSelectBackgroundEffect({ type: 'image', value: bg.src })}
            />
          ))}
        </div>
      </TabPanel>
      <TabPanel header="Animated" className="backgrounds-section">
        <div className={cn('backgrounds-section-grid', 'animation-section')}>
          {ANIMATED_BACKGROUND_VIDEOS.map((video) => (
            <img
              key={video.id}
              src={video.thumbnail}
              alt={video.name}
              className={cn('background-choice', {
                selected: selectedEffect.type === 'animation' && selectedEffect.value === video.src,
              })}
              onClick={() => onSelectBackgroundEffect({ type: 'animation', value: video.src })}
            />
          ))}
        </div>
      </TabPanel>
      <TabPanel header="Blur" className="backgrounds-section">
        <div className="backgrounds-section-grid">
          {BLURRED_BACKGROUNDS.map((bg) => (
            <label
              className="blur-box"
              key={bg.id}
              onClick={() => onSelectBackgroundEffect({ type: 'blur', value: bg.id })}
            >
              <div
                className={cn('blur-icon', {
                  selected: selectedEffect.type === 'blur' && bg.id === selectedEffect.value,
                })}
              >
                {bg.id === 'slight-blurred' ? (
                  <SlightlyBlurredIcon width={65} height={60} />
                ) : (
                  <FullyBlurredIcon width={65} height={60} />
                )}
              </div>
              <div className="blur-title">{bg.title}</div>
            </label>
          ))}
        </div>
      </TabPanel>
    </TabView>
  );
};

export default memo(BackgroundEffectsTabs);
